import { Copy } from '../copy/Copy';

export const NAV_LIST_ITEMS = [
  {
    name: Copy.generate('NavList.listItem.1'),
    to: '/about',
  },
  {
    name: Copy.generate('NavList.listItem.2'),
    to: '/demo',
  },
  {
    name: Copy.generate('NavList.listItem.3'),
    to: '/pricing',
  },
  {
    name: Copy.generate('NavList.listItem.4'),
    to: '/contact',
  },
  {
    name: Copy.generate('Global.help'),
    to: '/help',
  },
];
